import type { suppression as Fr } from '../fr/suppression';

/** « suppression » in English — typed on the French: a missing sentence does not compile. */
export const suppression: typeof Fr = {
  types: {
    vehicule: 'Vehicle', client: 'Customer', location: 'Rental', contrat: 'Agreement', facture: 'Invoice',
    caution: 'Deposit', entretien: 'Maintenance', amende: 'Fine', sinistre: 'Claim', assurance: 'Insurance',
  },
  aideVehicule: 'A vehicle that has been used is not deleted: archive it, it leaves the lists without losing anything.',
  aideLocation: 'A rental that has received money is cancelled, not erased: the cash register must keep its trace.',
  aideFacture: 'Invoices are numbered in sequence: a gap in the series will show.',
  contravention: 'ticket',
  police: 'policy',
  supprimee: (type: string, l: string) => `${type} “${l}” deleted. The audit log keeps a full copy.`,
  echec: 'The deletion failed.',
  titre: 'Delete a record',
  sousTitre: 'Permanent. The whole record is copied into the audit log before it disappears.',
  avertTitre: 'Before erasing, ask yourself whether cancelling or archiving would be enough',
  avertTexte: 'A cancelled rental stays in Outstanding with its money; an archived vehicle leaves the lists without losing its history. Deletion cannot be undone: only the copy in the audit log will show what the record contained.',
  fiches: (type: string, n: number) => `${type} — ${n} ${n === 1 ? 'record' : 'records'}`,
  chercher: 'Search…',
  rien: 'Nothing to show',
  supprimer: 'Delete',
  definitivement: 'Delete permanently',
  modaleTexte: 'This record will disappear from the software. The audit log will keep its full content, your name and the reason you write here.',
  motif: 'Reason (required)',
  motifAide: 'Why this record must no longer exist.',
  motifExemple: 'Duplicate entry, created by mistake during training…',
  annuler: 'Cancel',
};
